export default __webpack_public_path__ + "static/media/morning-cup-of-javascript-img.6305aac7.png";